//import axios from 'axios';
import axios from "./axios-common";
const DEBUG=true;

class TaskService {

  fetchTasks(){
    return axios
    .get(`/tasks`)
    .then(response => {
      return response.data;
    })
    .catch(err=>{
      return { success: false, error: err };
    });
  }

  setTaskStatus( { taskID, status } ) {
    return axios
    .put(`/task/${taskID}`, {status})
    .then(response => {
      if(DEBUG) console.debug('setTaskStatus', taskID, response.data);
      return response.data;
    })
    .catch(err=>{
      if(DEBUG) console.trace(err);
      return Promise.reject({message: err});
    });
  }

}

export default new TaskService();

//    this.message =
//      (error.response &&
//       error.response.data &&
//       error.response.data.message
//      ) ||
//       error.message ||
//       error.toString();
